import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';

const ErrorDialog = ({ open, onClose, title, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="error-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
        <ErrorOutlineIcon color="error" sx={{ mr: 1, fontSize: 30 }} />
        <Typography variant="h6" component="span" sx={{ flexGrow: 1 }}>
          {title || 'Error'}
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="error-dialog-description">
          {message || 'An unexpected error occurred.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary"
          sx={{ textTransform: 'none', px: 3 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ErrorDialog;